export default __webpack_public_path__ + "static/media/coin.7fbe1d15.svg";